import React from 'react';
import Layout from '../components/Layout';
// 修改导入语句 - 使用默认导入
import ToolCard from '../components/Tools/ToolCard';

const ToolsPage: React.FC = () => {
    return (
        <Layout>
            <div className="container">
                <h1>工具页面</h1>
                <div className="tool-cards">
                    <ToolCard 
                        title="Markdown 编辑器" 
                        description="上传和编辑 Markdown 文本" 
                        path="/" 
                    />
                    <ToolCard 
                        title="其他小工具" 
                        description="探索更多实用工具" 
                        path="/tools" 
                    />
                </div>
            </div>
        </Layout>
    );
};

export default ToolsPage;